export const TypeClassSession = {
  STUDENTS_AT_RISK: "Students at risk",
};
